import request from '../../../shared/request'

export function fetchRepairOrderTemplates() {
  return request(`/job/repair_order/templates`)
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteRepairOrders.js